/* src/app/layout/products-dropdown/products-dropdown.component.scss */
.di-product-dropdown {
  font-family: "Source Sans Pro", sans-serif;
  width: 150px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  text-align: left;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border: 0;
  margin-right: 24px;
  background: #f5f5f5 url("data:image/svg+xml,%3Csvg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.9375 10.125L6.0625 8L7 8.9375L3.9375 12L0.875 8.9375L1.8125 8L3.9375 10.125ZM3.9375 1.875L1.8125 4L0.875 3.0625L3.9375 0L7 3.0625L6.0625 4L3.9375 1.875Z' fill='%23212121'/%3E%3C/svg%3E%0A") no-repeat center right 10px;
}
.di-product-dropdown .material-symbols-outlined {
  font-size: 16px;
  height: 16px;
  width: 16px;
  margin-right: 5px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-dropdown-wrapper .category-wrapper {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.product-dropdown-wrapper .category-wrapper button.active {
  background-color: #f5f5f5;
}
.product-dropdown-wrapper .mat-mdc-menu-content {
  padding: 0 !important;
  min-width: 160px;
  background-color: #fff;
  text-transform: uppercase;
}
.product-dropdown-wrapper .mat-mdc-menu-content h5 {
  margin: 0;
  font-size: 12px;
  padding: 10px 15px 5px 15px;
  color: #999999;
  font-weight: 600;
  letter-spacing: 1px;
}
.product-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item {
  height: 35px;
  min-height: 35px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 35px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
}
.product-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
  width: 100%;
}
.product-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item .material-symbols-outlined {
  margin-right: 10px;
  font-size: 16px;
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=products-dropdown.component-FFPHOM4U.css.map */
